var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBolt = function SvgBolt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#4A4A4A",
    strokeWidth: 1.5,
    d: "M12.915 10a2.917 2.917 0 1 1-5.833 0 2.917 2.917 0 0 1 5.833 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4A4A4A",
    strokeWidth: 1.5,
    d: "M17.327 7.627c.672 1.158 1.008 1.737 1.008 2.373s-.336 1.215-1.008 2.373l-1.603 2.764c-.67 1.153-1.004 1.73-1.554 2.046-.55.317-1.219.317-2.554.317h-3.23c-1.335 0-2.003 0-2.553-.317-.55-.316-.885-.893-1.554-2.046l-1.603-2.764C2.004 11.215 1.668 10.636 1.668 10s.336-1.215 1.008-2.373l1.603-2.763c.67-1.154 1.004-1.73 1.554-2.047S7.051 2.5 8.387 2.5h3.229c1.335 0 2.003 0 2.554.317.55.316.885.893 1.554 2.047z"
  })));
};
export default SvgBolt;